var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "148311d9-c125-4449-a148-b8fa33f3c561",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 627.45,
    height: 759,
    viewBox: "0 0 627.45 759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fe24b365-19a0-4a71-abdc-76e4b2fc8dee",
    x1: 313.72,
    y1: 759,
    x2: 313.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f1e26e3d-9d52-4866-b24c-036458e443cc",
    x1: 313.72,
    y1: 455.23,
    x2: 313.72,
    y2: 213.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b3b3b3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3",
    stopOpacity: 0.05
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blog") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 627.45,
    height: 759,
    fill: "url(#fe24b365-19a0-4a71-abdc-76e4b2fc8dee)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.58,
    y: 5.49,
    width: 612.28,
    height: 736.45,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 52.74,
    width: 240.74,
    height: 19.72,
    fill: "#64ffda"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 513.37,
    width: 240.74,
    height: 19.72,
    fill: "#64ffda"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 92.18,
    width: 526.03,
    height: 19.72,
    fill: "#e0e0e0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 131.63,
    width: 526.03,
    height: 19.72,
    fill: "#e0e0e0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46.44,
    y: 213.09,
    width: 534.56,
    height: 242.14,
    fill: "url(#f1e26e3d-9d52-4866-b24c-036458e443cc)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 51.18,
    y: 216.78,
    width: 526.03,
    height: 231.2,
    fill: "#2c7be5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 637.59,
    width: 526.03,
    height: 19.72,
    fill: "#e0e0e0"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 678.34,
    width: 526.03,
    height: 19.72,
    fill: "#e0e0e0"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 597.05,
    width: 526.03,
    height: 19.72,
    fill: "#e0e0e0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 556.51,
    width: 526.03,
    height: 19.72,
    fill: "#e0e0e0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.740950e4bc203dcd3deff68a1a4e7ccd.svg";
export { ForwardRef as ReactComponent };